export default "__VITE_ASSET__ePpWqV0n__"